import { Pipe, PipeTransform } from '@angular/core';
import { CustomProductAttributeConfig } from '../../../types';

@Pipe({
    name: 'checkedOrUnchecked',
    standalone: false
})
export class CheckedOrUncheckedPipe implements PipeTransform {
  transform(item: CustomProductAttributeConfig, value) {
    return Object.entries(value).find(
      (value1) => value1[0] === item.customId
    )[1];
  }
}
